module.exports = __webpack_public_path__ + "static/media/avatar2.b5612632.png";